import { useState, useEffect } from "react";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAppSelector } from "../../app/hook";
import { useGetGwCompaniesDownloadQuery } from "../../features/api";
import type { RootState } from "../../app/store";

const Footer = () => {
  const [downloadAction, setDownloadAction] = useState(false);

  const searchCondition = useAppSelector(
    (state: RootState) => state.gwSearchCondition
  );
  useGetGwCompaniesDownloadQuery(searchCondition, { skip: !downloadAction });

  const { visible } = useAppSelector((state) => state.modal);

  useEffect(() => {
    // モーダル閉じる場合にフラグを戻す
    if (!visible) {
      setDownloadAction(false);
    }
  }, [visible]);

  return <SpaceBetween size="m"></SpaceBetween>;
};

export default Footer;
